
export type GetNotifications200NotificationsItemTarget = {
  /** @nullable */
  targetId?: number | null;
  /** @nullable */
  targetType?: string | null;
};
